import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';

import { useLocationAutocompleteContext } from './LocationAutocompleteContext';

interface ILocationFilterInputProps {
  label: string;
}

export const LocationFilterInput = ({ label }: ILocationFilterInputProps) => {
  const { isOpened, inputProps } = useLocationAutocompleteContext();

  return (
    <div className="relative flex flex-col justify-center w-full p-4 overflow-hidden text-left h-[100px]">
      <Text
        variant={
          isOpened || inputProps.value
            ? ETextStyleVariant.LegalRegular
            : ETextStyleVariant.LargeRegular
        }
        component="span"
        className={cn('text-gray-500 truncate absolute transition-all duration-300 ease-in-out', {
          '-translate-y-3': isOpened || inputProps.value,
          'translate-y-0': !(isOpened || inputProps.value),
        })}>
        {label}
      </Text>

      <input
        {...inputProps}
        className={cn(
          'absolute inset-0 z-10 bg-transparent p-4 pt-[34px] text-ellipsis',
          'text-gray-800 tracking-normal text-lg font-medium',
          {
            'placeholder-transparent': !isOpened,
            'placeholder-gray-800': isOpened,
          },
        )}
        onFocus={e => e.target.select()}
      />

      {isOpened && <div className="absolute z-20 w-full" />}
    </div>
  );
};
